export const DragDrop = {
  mounted() {
    let dropArea = document.getElementById(this.el.id);

    dropArea.addEventListener(
      "dragenter",
      (_e) => {
        if (dropArea.dataset.dragOver === "true") {
          return;
        } else {
          dropArea.setAttribute("data-drag-over", "true");
        }
      },
      false,
    );

    dropArea.addEventListener(
      "dragleave",
      (e) => {
        // dragleave between the element's children and itself complicates things,
        // so we'll ignore those within the same bounding box.
        let rect = dropArea.getBoundingClientRect();
        if (
          dropArea.dataset.dragOver === "true" &&
          (e.clientY < rect.top ||
            e.clientY >= rect.bottom ||
            e.clientX < rect.left ||
            e.clientX >= rect.right)
        ) {
          dropArea.removeAttribute("data-drag-over");
        }
      },
      false,
    );
  },
};
